import { useMemo } from 'react';
import { useAuth } from '../../../../../authContext';
import { useSecurity } from '../../../../../SecurityContext';
import { linkedHandlesIncludeMaster } from './dashboardUtils';
import { normalizeRosterStr } from '../../rosterTools/utils/rosterHelpers';

export function useDashboardRibbonsAccess(player) {
  const { isLoggedIn, userId, handles } = useAuth();
  const { subjectHasPermission, isViewAsActive, viewAsUserId } = useSecurity();

  const isOwner = useMemo(() => {
    if (!isLoggedIn || !player) return false;

    if (isViewAsActive) {
      if (viewAsUserId != null && player.userId != null) {
        if (Number(player.userId) === Number(viewAsUserId)) return true;
      }
      return subjectHasPermission('private.navbar.personalhub.ribbons', 'read');
    }

    if (linkedHandlesIncludeMaster(handles)) return true;

    const puid = player.userId;
    if (puid != null && userId != null) return Number(puid) === Number(userId);

    const rosterHandle = normalizeRosterStr(player.rosterHandle);
    if (!rosterHandle) return false;
    const authHandles = Array.isArray(handles) ? handles : [];
    return authHandles.some(
      (h) => h?.linkedToUser && normalizeRosterStr(h?.handle) === rosterHandle,
    );
  }, [handles, isLoggedIn, isViewAsActive, player, subjectHasPermission, userId, viewAsUserId]);

  const canSeeAllRibbons = useMemo(() => {
    if (isOwner) return true;
    return subjectHasPermission('private.navbar.roster.file.ribbons.all', 'read');
  }, [isOwner, subjectHasPermission]);

  return { canSeeAllRibbons };
}
